<template>
  <div class="base cape">
    <inside-header title="工单详情" right-link-name="UserWorkOrder" />
    <van-form @submit="onSubmit">
      <div class="mode">
        <div class="other-info">
          <div class="node">
            问题分类：{{ info.type }}
          </div>
          <div class="apply-time">
            提交时间：{{ info.create_time | dayFormat }}
          </div>
        </div>
        <div class="wape">
          <div class="left">
            {{ info.title }}
          </div>
          <div class="right">
            {{ info.status | filterStatus }}
          </div>
        </div>
        <div class="description">
          描述：{{ info.content }}
        </div>
        <div v-if="infoAttachmentList.length > 0" class="attachment-list" style="text-align: left;">
          <img v-for="(val, ii) in infoAttachmentList" :key="ii" class="attachment-img" :src="val.url_base64" alt="">
        </div>
      </div>
      <div v-if="worksheetReply.length > 0" class="case">
        <div class="cool">
          沟通记录
        </div>
        <van-steps direction="vertical" :active="0" active-color="#ff5c00">
          <van-step v-for="(item, index) in worksheetReply" v-show="index < 4 || showPicker" :key="index">
            <div class="cool-first">
              <div>{{ item.admin ? item.admin : item.nick_name }}</div>
              <div>{{ item.create_time | timeFormat }}</div>
            </div>
            <div>{{ item.content }}</div>
            <div v-if="item.attachment_list" class="attachment-list">
              <img v-for="(attach, i) in item.attachment_list" :key="i" class="attachment-img" :src="attach.url_base64"
                alt="">
            </div>
          </van-step>
        </van-steps>
        <div class="hepe">
          <a-button type="link" @click="showPicker = !showPicker">
            {{ showPicker ? '折叠' : '查看更多'
            }}
            <a-icon type="double-right" :rotate="showPicker ? 270 : 90" />
          </a-button>
        </div>
      </div>
      <!-- <input type="hidden" name="id" :value="id">原生的id隐藏的写法 -->
      <div class="pass">
        <van-field v-model="message" rows="2" name="content" autosize type="textarea" maxlength="100" placeholder="回复内容"
          show-word-limit />
      </div>
      <div class="sodium">
        <van-field readonly label="附件">
          <template #input>
            <a-upload action="/api/index/file/uploadProtectedImage" name="image" :multiple="true" :headers="headers"
              accept="image/png,image/jpeg" :file-list="enclosureFileList" @change="uploadChange">
              <a-button>
                <a-icon type="upload" /> 点击上传
              </a-button>
            </a-upload>
          </template>
        </van-field>
      </div>
      <div style="margin: 16px;text-align:center" class="btn-area">
        <van-button round block native-type="submit" color="#ff5c00">
          提交回复
        </van-button>
      </div>
      <div style="margin: 10px 16px;text-align:center" class="btn-area">
        <van-button class="del-btn" native-type="button" round block color="#ee0a24" @click="goDown(id)">
          关闭工单
        </van-button>
      </div>
    </van-form>
  </div>
</template>
<script>
import { InsideHeader } from '@/components'
import store from '@/store/'
export default {
  name: 'WorkOrderDetails',
  components: {
    InsideHeader
  },
  filters: {
    // 将当前的值传进来，然后处理并将返回值传出去,filters处理英文转为中文等值不符合规矩的函数
    filterStatus(val) {
      if (val === 'Open') {
        return '进行中'
      } else if (val === 'AdminReply') {
        return '已回复'
      } else if (val === 'UserReply') {
        return '未回复'
      } else {
        return '已关闭'
      }
    }
  },
  props: {
    id: {}
  },
  data() {
    return {
      info: [],
      // 首次提交的附件
      infoAttachmentList: [],
      title: '',
      showPicker: false,
      message: '',
      headers: {
        authorization: store.getters.token
      },
      worksheet_reply: [],
      worksheetReply: [],
      // 上传附件图片
      attachment: [],
      reply_content: '',
      workOrderStatus: '',
      enclosureFileList: [],
      loadAttachment: true
    }
  },
  watch: {
    info(val) {
      const winThis = this
      // 初次提交的附件
      if (val.attachment_list !== undefined) {
        const attachmentList = val.attachment_list
        // 循环列表数据
        attachmentList.forEach((vvv, index) => {
          const url = vvv.url
          // 居然成功了，循环获取图片的base64
          new Promise(resolve => {
            winThis
              .$http({
                url: url,
                method: 'get'
              })
              .then(res => {
                vvv.url_base64 = res
                resolve(vvv)
              })
          }).then(re => {
            winThis.$set(winThis.infoAttachmentList, index, re)
          })
        })
      }
    },
    // 回复数据，需要处理其中的附件用于显示
    worksheet_reply(list) {
      this.loadAttachment = true
      const winThis = this
      // 循环列表数据
      list.forEach((item, index) => {
        // 存在附件列表
        if (item.attachment_list !== undefined) {
          var attachmentList = item.attachment_list
          attachmentList.forEach(i => {
            const url = i.url
            // 居然成功了，循环获取图片的base64
            new Promise(resolve => {
              winThis
                .$http({
                  url: url,
                  method: 'get'
                })
                .then(res => {
                  i.url_base64 = res
                  resolve(i)
                })
            }).then(() => {
              winThis.$set(winThis.worksheetReply, index, item)
            })
          })
        } else {
          // 不存在附件列表
          winThis.$set(winThis.worksheetReply, index, item)
        }
      })
      this.loadAttachment = false
    }
  },
  created() {
    console.log(this.id)
    this.loadData(this.id)
  },
  methods: {
    loadData(id) {
      this.$http({
        url: 'index/worksheet/info',
        method: 'get',
        params: {
          id: id
        }
      }).then(res => {
        console.log(res)
        var data = res.data
        var info = data.info
        this.info = data.info
        this.worksheet_reply = info.worksheet_reply
      })
    },
    uploadChange(e) {
      const attachment = []
      e.fileList.forEach(item => {
        if (item.response !== undefined && item.response.status === 'success') {
          attachment.push(item.response.data)
        }
      })
      this.attachment = attachment
      this.enclosureFileList = e.fileList
      if (Array.isArray(e)) {
        return e
      }
      return e && e.fileList
    },
    onSubmit(values) {
      values.id = this.id // 在提交的参数中加个id
      values.attachment = this.attachment
      this.$http({
        url: 'index/worksheet/reply',
        method: 'post',
        data: values
      }).then(res => {
        console.log(res)
        if (res.status === 'success') {
          this.$toast.success('回复成功')
          this.attachment = []
          this.enclosureFileList = []
          this.message = ''
          this.loadData(this.id)
        } else {
          this.$toast.fail(res.message)
        }
      })
    },
    goDown(id) {
      this.$dialog
        .confirm({
          title: '注意',
          message: '是否关闭该工单'
        })
        .then(() => {
          this.$http({
            url: 'index/worksheet/close',
            method: 'post',
            data: {
              id: id
            }
          }).then(res => {
            if (res.status === 'success') {
              this.$router.push({ name: 'UserWorkOrder' })
            }
          })
        })
    }
  }
}
</script>
<style lang="stylus" scoped>
.cape {
    padding: 15px;
    min-width: 280px;
    max-width: 420px;
    .mode {
        padding: 30px 15px;
        margin-top: 15px;
        box-shadow: 0 0 10px 0 rgba(216,216,216,0.3);

        .other-info {
          overflow hidden
          .node {
            float: left;
            font-size: 12px;
            color: #999999;
          }
          .apply-time {
            float: right;
            font-size: 12px;
            color: #999999;
          }
        }

        .wape {
            overflow: hidden;
            margin-top: 10px;
            .left {
                float: left;
                font-size: 16px;
                color: #333333;
                font-weight: bold;
            }
            .right {
                float:right;
                width: 60px;
                height: 20px;
                background-color: #def4e4;
                border-radius: 10px;
                color: #5bc979;
                font-size: 12px;
                text-align: center;
                line-height: 20px;
            }
        }

        .description {
          font-size: 15px;
          color: #333;
          margin-top: 12px;
        }
    }
    .case {
        padding: 30px 15px 15px 15px;
        box-shadow: 0 0 10px 0 rgba(216,216,216,0.3);
        margin-top: 10px;
        .cool {
            font-size: 16px;
            color: #333333;
        }
        .hepe {
            text-align: center
        }
        .cool-first {
            overflow:hidden;
            height:25px;
            div:nth-child(1) {
                float: left;
            }
            div:nth-child(2) {
                float: right;
                color: #ccc;
            }
        }

        .attachment-list {
          margin-top: 10px;
          text-align: right;
          .attachment-img {
            margin-left: 10px;
            height: 60px;
          }
        }
    }
    .pass {
        margin-top: 15px;
        box-shadow: 0 0 10px 0 rgba(216,216,216,0.3);
    }
    .sodium {
        margin-top: 15px;
    }
}

.del-btn {
  width: 315px;
  height: 40px;
  background-color: #f9f9f9;
  border-radius: 10px;
  color: $theme-color;
}

.attachment-list {
  margin-top: 10px;
  text-align: right;
  .attachment-img {
    margin-left: 10px;
    height: 40px;
  }
}
</style>
